import {
  Button,
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  Flex,
  FormControl,
  FormErrorMessage,
  FormHelperText,
  FormLabel,
  Input,
  Select,
} from "@chakra-ui/react";
import { yupResolver } from "@hookform/resolvers/yup";
import React, { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import * as yup from "yup";
import useAxios from "axios-hooks";

import { toastState } from "atoms/toastState";
import { updateConnectorDrawerState } from "atoms/updateConnectorDrawerState";
import Card from "components/card/Card";
import LoadingSpinner from "components/feedback/LoadingSpinner";
import logger from "infra/logger";
import {
  updateChargePointConnectorSelectOptions,
  formatTypeMapping,
} from "../variables/chargePointConnectorSelectOptions";

const UpdateChargePointConnectorDrawer = () => {
  const [connector, SetConnector] = useState(null);
  const drawer = useRecoilValue(updateConnectorDrawerState);
  const setToast = useSetRecoilState(toastState);
  const [drawerState, setDrawerState] = useRecoilState(
    updateConnectorDrawerState,
  );
  const [
    { data: updateData, loading: updateLoading, error: updateError },
    UpdateConnector,
  ] = useAxios(
    { method: "PATCH", url: `/api/evses/update/${drawer.activeId}` },
    { manual: true },
  );

  const [
    { data: getData, loading: getLoadiing, error: getError },
    getConnector,
  ] = useAxios(
    { method: "Get", url: `/api/evses/${drawer.activeId}` },
    { manual: true },
  );
  const validationSchema = yup.object().shape({
    EvseSerialId: yup.number(),
    Standard: yup
      .string()
      .oneOf(
        ["AC Type 1", "AC Type 2", "CCS Type 2", "CHAdeMO", "DOMESTIC_D"],
        "Select a valid option",
      ),
    Format: yup.string(),
  });

  const {
    control,
    handleSubmit,
    formState: { errors, isValid },
    register,
    setValue,
    getValues,
    watch,
  } = useForm({
    mode: "onChange",
    resolver: yupResolver(validationSchema),
  });

  // Watch format field changes
  const formatValue = watch("Format");

  const updateHandler = async () => {
    const formValues = getValues();
    let data = {};

    if (
      formValues.EvseSerialId > 0 &&
      formValues.EvseSerialId != connector.EvseSerialId
    ) {
      data["EvseSerialId"] = parseInt(formValues.EvseSerialId);
    }
    if (
      formValues.Standard.trim() !== "" &&
      formValues.Standard.trim() !== connector?.Connectors[0]?.Standard
    ) {
      data["Standard"] = formValues.Standard.trim();
    }
    if (
      formValues.Format.trim() !== "" &&
      formValues.Format.trim() !== connector?.Connectors[0]?.Format
    ) {
      data["Format"] = formValues.Format.trim();
    }
    if (Object.keys(data).length > 0) {
      try {
        const response = await UpdateConnector({ data: data });
        console.log(response.data.data);
        setToast({
          isOpen: true,
          title: "Connector Updated Successfully",
          status: "success",
        });
      } catch (error) {
        const err = error?.response?.data?.error;
        logger.log(error);
        setToast({
          isOpen: true,
          title: "Error occured when updating Connector",
          description: err ? err : null,
          status: "error",
        });
      }
      closeHandler();
    } else {
      setToast({
        isOpen: true,
        title: "Nothing new to Update Connector",
        status: "warning",
        position: "top",
      });
    }
  };
  const fetchConnector = async () => {
    try {
      const response = await getConnector();
      SetConnector(response.data.data);
    } catch (error) {
      logger.log(error);
    }
  };

  const closeHandler = () => {
    setDrawerState(null);
  };

  useEffect(() => {
    fetchConnector();
  }, []);
  useEffect(() => {
    if (connector) {
      setValue("EvseSerialId", connector.EvseSerialId);
      setValue("Format", connector?.Connectors[0]?.Format);
      setValue("Standard", connector?.Connectors[0]?.Standard);
    }
  }, [connector]);
  return (
    <Drawer
      isOpen={drawerState?.isOpen}
      placement="right"
      onClose={closeHandler}
      size="md"
    >
      <DrawerOverlay />
      <DrawerContent>
        <DrawerCloseButton />
        <DrawerHeader>Update Connector Details</DrawerHeader>
        <DrawerBody>
          {getLoadiing || updateLoading ? (
            <LoadingSpinner />
          ) : (
            <Card>
              <form>
                {updateChargePointConnectorSelectOptions.map((item, index) => {
                  // Get filtered options for Type of Evse based on selected format
                  let optionsToShow = item.options;
                  if (item.name === "Standard" && formatValue) {
                    optionsToShow = formatTypeMapping[formatValue] || [];
                  }

                  return (
                    <Flex key={index} mb="20px" alignItems="center">
                      <Controller
                        name={item.name}
                        control={control}
                        defaultValue=""
                        render={({ field }) => (
                          <FormControl
                            isRequired
                            flexDirection="row"
                            isInvalid={errors[item.name]}
                          >
                            <FormLabel fontSize={16}>{item.label}</FormLabel>
                            {item.type === "select" ? (
                              <Select
                                {...field}
                                focusBorderColor="brand.500"
                                fontSize="sm"
                                width={{ base: "100%", md: "400px" }}
                                height="50px"
                                onChange={(e) => {
                                  field.onChange(e);
                                  // Reset Standard field when Format changes
                                  if (item.name === "Format") {
                                    setValue("Standard", "");
                                  }
                                }}
                                isDisabled={
                                  item.name === "Standard" && !formatValue
                                }
                              >
                                <option value="">Select</option>
                                {optionsToShow.map((option, ind) => {
                                  return (
                                    <option key={ind} value={option.value}>
                                      {option.name}
                                    </option>
                                  );
                                })}
                              </Select>
                            ) : (
                              <Input
                                {...field}
                                focusBorderColor="brand.500"
                                fontSize="sm"
                                placeholder={item.placeholder}
                                width={{ base: "100%", md: "400px" }}
                                height="50px"
                                type={item.type}
                                isRequired
                              />
                            )}
                            <FormHelperText color={"brand.500"}>
                              {item.helper}
                            </FormHelperText>
                            <FormErrorMessage mb={"20px"}>
                              {errors[item.name] && errors[item.name].message}
                            </FormErrorMessage>
                          </FormControl>
                        )}
                      />
                    </Flex>
                  );
                })}
              </form>
            </Card>
          )}
        </DrawerBody>
        <DrawerFooter flexWrap="wrap" gap={2}>
          <Button
            variant="outline"
            onClick={closeHandler}
            flex={{ base: "1", md: "0" }}
            minW={{ base: "auto", md: "100px" }}
          >
            Cancel
          </Button>
          <Button
            bg="brand.500"
            color="white"
            colorScheme="brand"
            onClick={handleSubmit(updateHandler)}
            isLoading={updateLoading}
            flex={{ base: "1", md: "0" }}
            minW={{ base: "auto", md: "100px" }}
          >
            Update
          </Button>
        </DrawerFooter>
      </DrawerContent>
    </Drawer>
  );
};

export default UpdateChargePointConnectorDrawer;
